import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function usePropertiesReports(agencyId) {
  const staleTime = 600000;
  const queryClient = useQueryClient();

  const { get, post, put, del } = useApiHelper();

  const propertiesStats = useQuery(
    ["propertiesStats", agencyId],
    () => get(`/Reports/${agencyId}/propertystats`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  return {
    propertiesStats,
  };
}
